<template>
  <ScrollToTopButton v-if="!isAtTop" @click="scrollToElement('body')" />
  <Navbar noticias=".noticias" contactos=".contactos" />
  <section class="hero">
    <div class="heroContent">
      <div class="textArea">
        <h1 class="slogan">
          Núcleo de Estudantes de<br />Engenharia Informática
        </h1>
        <p class="heroText">
          O NEEI tem como objectivo apoiar os alunos do departamento de
          informática da Universidade de Évora, tanto a nivel escolar, como a
          nivel professional.
        </p>
        <div class="buttons">
          <button @click="scrollToElement('.features')" class="vantagens">
            Junta-te ao núcleo!
          </button>
        </div>
      </div>
      <img class="heroImage" src="@/assets/digitalNomad.svg" alt="" />
    </div>
  </section>
  <section class="features">
    <h1>Como te podemos ajudar?</h1>
    <p class="subtitle">
      De modo a ajudar os alunos do curso, o NEEI organiza diversos eventos
      lúdicos e profissionais para aprimorar a vida académica dos estudantes
    </p>
    <div class="feature">
      <div class="palestra">
        <svg
          version="1.1"
          :width="width"
          :height="height"
          id="Layer_1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 484.699 484.699"
          style="enable-background:new 0 0 484.699 484.699;"
          xml:space="preserve"
        >
          <g id="XMLID_808_">
            <g id="XMLID_732_">
              <circle
                style="fill:#F7931E;"
                cx="333.231"
                cy="196.909"
                r="143.895"
              />
            </g>
            <g id="XMLID_777_">
              <circle
                style="fill:#FBB03B;"
                cx="306.724"
                cy="200.696"
                r="117.388"
              />
            </g>
            <g id="XMLID_810_">
              <polygon
                style="fill:#FFFFFF;"
                points="219.629,159.042 204.482,159.042 204.482,120.939 219.629,113.601 		"
              />
            </g>
            <g id="XMLID_450_">
              <path
                style="fill:#E9483D;"
                d="M148.19,151.468h6.574c77.651,0,140.6,62.949,140.6,140.6v139.617H147.173
                  c-77.099,0-139.6-62.501-139.6-139.6l0,0C7.573,214.425,70.53,151.468,148.19,151.468z"
              />
            </g>
            <g id="XMLID_645_">
              <circle
                style="fill:#ED6D64;"
                cx="128.748"
                cy="272.643"
                r="121.175"
              />
            </g>
            <g id="XMLID_696_">
              <polygon
                style="fill:#FFFFFF;"
                points="30.293,355.951 13.008,336.24 13.008,231.439 30.293,219.629 		"
              />
            </g>
            <g id="XMLID_449_">
              <g id="XMLID_430_">
                <path
                  style="fill:#1D1D1B;"
                  d="M333.231,45.44c-62.799,0-118.579,38.439-141.149,96.419c-12.931-3.603-26.55-5.537-40.614-5.537
                    C67.948,136.322,0,204.27,0,287.79s67.948,151.469,151.468,151.469h151.469v-90.881h30.294
                    c83.52,0,151.468-67.948,151.468-151.468C484.699,113.389,416.751,45.44,333.231,45.44z M287.79,424.112H151.468
                    c-75.168,0-136.322-61.154-136.322-136.322S76.3,151.468,151.468,151.468S287.79,212.622,287.79,287.79V424.112z
                    M333.231,333.231h-30.294V287.79c0-64.121-40.052-119.059-96.45-141.123c20.488-51.787,70.477-86.081,126.744-86.081
                    c75.168,0,136.322,61.154,136.322,136.322C469.553,272.077,408.399,333.231,333.231,333.231z"
                />
                <g id="XMLID_428_">
                  <g id="XMLID_431_">
                    <path
                      style="fill:#1D1D1B;"
                      d="M110.513,265.044h15.324v8.272c0,3.617-0.429,6.305-1.287,8.069
                        c-0.862,1.764-2.737,4.094-5.628,6.986l-9.899,9.9c-2.082,2.259-3.121,5.063-3.121,8.405c0,3.347,1.087,6.128,3.254,8.343
                        c2.171,2.215,4.974,3.321,8.409,3.321s6.305-1.061,8.613-3.188c2.304-2.123,3.635-4.948,3.998-8.476h16.412
                        c-0.906,8.047-4.049,14.356-9.426,18.919c-5.381,4.567-12.092,6.849-20.139,6.849s-14.6-2.193-19.662-6.579
                        c-5.063-4.382-7.592-10.51-7.592-18.375c0-5.425,1.49-9.944,4.475-13.56c1.716-2.167,3.025-3.705,3.931-4.611
                        c0.902-0.902,2.104-2.052,3.594-3.458c1.49-1.398,2.755-2.618,3.798-3.661c1.035-1.039,1.875-1.964,2.507-2.781
                        c1.627-1.897,2.441-4.652,2.441-8.269v-6.106H110.513z M117.906,234.943c2.847,0,5.31,0.973,7.389,2.914
                        c2.078,1.945,3.121,4.293,3.121,7.052s-1.017,5.133-3.051,7.119c-2.034,1.99-4.478,2.984-7.326,2.984s-5.31-0.973-7.389-2.918
                        c-2.082-1.941-3.121-4.29-3.121-7.052c0-2.755,1.017-5.129,3.051-7.119C112.618,235.937,115.058,234.943,117.906,234.943z"
                    />
                  </g>
                  <g id="XMLID_441_">
                    <path
                      style="fill:#1D1D1B;"
                      d="M192.423,302.064h-15.324v-8.269c0-3.617,0.425-6.309,1.287-8.069
                        c0.858-1.764,2.733-4.09,5.628-6.986l9.899-9.9c2.078-2.259,3.117-5.063,3.117-8.405c0-3.347-1.084-6.124-3.254-8.343
                        c-2.171-2.211-4.974-3.321-8.405-3.321c-3.439,0-6.309,1.065-8.613,3.188s-3.639,4.948-4.001,8.476H156.35
                        c0.902-8.047,4.046-14.352,9.426-18.919c5.377-4.563,12.089-6.849,20.135-6.849c8.047,0,14.6,2.193,19.666,6.579
                        c5.059,4.386,7.592,10.51,7.592,18.375c0,5.421-1.49,9.944-4.475,13.56c-1.719,2.167-3.029,3.705-3.931,4.608
                        c-0.906,0.906-2.104,2.06-3.594,3.461c-1.494,1.401-2.759,2.622-3.798,3.661s-1.879,1.919-2.507,2.644
                        c-1.627,1.989-2.441,4.792-2.441,8.405L192.423,302.064L192.423,302.064z M185.031,332.169c-2.847,0-5.31-0.969-7.392-2.914
                        c-2.078-1.941-3.117-4.293-3.117-7.052c0-2.755,1.017-5.129,3.051-7.119s4.475-2.984,7.322-2.984s5.31,0.973,7.392,2.918
                        c2.078,1.945,3.117,4.293,3.117,7.048c0,2.759-1.017,5.133-3.051,7.122C190.319,331.178,187.879,332.169,185.031,332.169z"
                    />
                  </g>
                </g>
              </g>
              <g id="XMLID_445_">
                <g id="XMLID_446_">
                  <rect
                    x="299.025"
                    y="189.336"
                    style="fill:#1D1D1B;"
                    width="15.147"
                    height="15.146"
                  />
                </g>
                <g id="XMLID_447_">
                  <rect
                    x="329.319"
                    y="189.336"
                    style="fill:#1D1D1B;"
                    width="15.147"
                    height="15.146"
                  />
                </g>
                <g id="XMLID_448_">
                  <rect
                    x="359.613"
                    y="189.336"
                    style="fill:#1D1D1B;"
                    width="15.146"
                    height="15.146"
                  />
                </g>
              </g>
            </g>
          </g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
        </svg>
        <h2>Palestras</h2>
        <p>Palestras cenas , talks com profissionais da indústria</p>
      </div>
      <div class="networking">
        <svg
          version="1.1"
          :width="width"
          :height="height"
          id="Layer_1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 512 512"
          style="enable-background:new 0 0 512 512;"
          xml:space="preserve"
        >
          <circle style="fill:#273B7A;" cx="256" cy="256" r="256" />
          <path
            style="fill:#121149;"
            d="M260.844,511.938c129.889-2.412,236.118-101.552,249.68-228.417l-85.533-85.532l-2.108,3.205
              l-58.606-58.609l-21.525-4.903l-68.003-69.299l-4.682,32.682l-86.159,19.634l-68.118,68.118l-4.31,16.331l-19.477,28.131
              l29.243,29.243l-69.844,39.979L260.844,511.938z"
          />
          <path
            style="fill:#38C6D9;"
            d="M412.875,256c0-86.118-69.753-156.239-155.726-156.86v10.357
              c80.268,0.624,145.382,66.091,145.382,146.503S337.418,401.88,257.15,402.503v10.357C343.123,412.239,412.875,342.118,412.875,256z"
          />
          <path
            style="fill:#71E2EF;"
            d="M256,402.532c-80.798,0-146.532-65.734-146.532-146.532S175.202,109.468,256,109.468
              c0.386,0,0.765,0.026,1.15,0.029V99.14c-0.384-0.003-0.765-0.016-1.15-0.016c-86.502,0-156.875,70.373-156.875,156.875
              S169.498,412.875,256,412.875c0.384,0,0.765-0.012,1.15-0.016v-10.357C256.765,402.506,256.386,402.532,256,402.532z"
          />
          <path
            style="fill:#FF7F4F;"
            d="M200.039,174.73c0-30.904,25.055-55.958,55.961-55.958s55.961,25.054,55.961,55.96L200.039,174.73z"
          />
          <path
            style="fill:#D35933;"
            d="M256.862,118.793v55.937h55.099C311.961,144.113,287.37,119.255,256.862,118.793z"
          />
          <circle style="fill:#FF7F4F;" cx="256.896" cy="86.247" r="25.207" />
          <path
            style="fill:#D35933;"
            d="M256.903,61.047c-0.014,0-0.028,0.002-0.041,0.002v50.412c0.014,0,0.028,0.002,0.041,0.002
              c13.922,0,25.207-11.285,25.207-25.207S270.826,61.047,256.903,61.047z"
          />
          <path
            style="fill:#FF7F4F;"
            d="M200.039,430.264c0-30.904,25.055-55.958,55.961-55.958s55.961,25.054,55.961,55.96L200.039,430.264z
              "
          />
          <path
            style="fill:#D35933;"
            d="M256.862,374.327v55.937h55.099C311.961,399.65,287.37,374.791,256.862,374.327z"
          />
          <circle style="fill:#FF7F4F;" cx="256.896" cy="341.782" r="25.207" />
          <path
            style="fill:#D35933;"
            d="M256.903,316.583c-0.014,0-0.028,0.002-0.041,0.002v50.412c0.014,0,0.028,0.002,0.041,0.002
              c13.922,0,25.207-11.285,25.207-25.207C282.11,327.868,270.826,316.583,256.903,316.583z"
          />
          <path
            style="fill:#FFC61B;"
            d="M51.402,302.497c0-30.904,25.055-55.958,55.961-55.958s55.961,25.054,55.961,55.96L51.402,302.497z"
          />
          <path
            style="fill:#EAA22F;"
            d="M108.225,246.56v55.937h55.099C163.325,271.882,138.731,247.024,108.225,246.56z"
          />
          <circle style="fill:#FFC61B;" cx="108.266" cy="214.023" r="25.207" />
          <path
            style="fill:#EAA22F;"
            d="M108.266,188.814c-0.014,0-0.028,0.002-0.041,0.002v50.412c0.014,0,0.028,0.002,0.041,0.002
              c13.922,0,25.207-11.285,25.207-25.207C133.473,200.101,122.187,188.816,108.266,188.814z"
          />
          <path
            style="fill:#FFC61B;"
            d="M348.677,302.497c0-30.904,25.055-55.958,55.961-55.958s55.961,25.054,55.961,55.96L348.677,302.497z
              "
          />
          <path
            style="fill:#EAA22F;"
            d="M405.499,246.56v55.937h55.099C460.598,271.882,436.007,247.024,405.499,246.56z"
          />
          <circle style="fill:#FFC61B;" cx="405.549" cy="214.023" r="25.207" />
          <path
            style="fill:#EAA22F;"
            d="M405.54,188.814c-0.014,0-0.028,0.002-0.041,0.002v50.412c0.014,0,0.028,0.002,0.041,0.002
              c13.922,0,25.207-11.285,25.207-25.207C430.749,200.101,419.462,188.816,405.54,188.814z"
          />
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
        </svg>
        <h2>Networking</h2>
        <p>
          Disponibilizamos uma sala para os alunos do curso e diversos eventos
          técnicos e lúdidos como CTFs , LAN Parties
        </p>
      </div>
      <div class="plataformas">
        <svg
          version="1.1"
          :width="width"
          :height="height"
          id="Layer_1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 511.999 511.999"
          style="enable-background:new 0 0 511.999 511.999;"
          xml:space="preserve"
          fill="#1935A1"
        >
          <g>
            <g>
              <path
                d="M504.642,207.408l-44.917-4.491c-4.868-18.741-12.299-36.659-22.152-53.415l28.603-34.96
                  c2.657-3.248,2.423-7.983-0.546-10.95L408.409,46.37c-2.969-2.967-7.701-3.205-10.951-0.546l-34.96,28.603
                  c-16.757-9.853-34.673-17.285-53.415-22.152l-4.491-44.917c-0.418-4.178-3.933-7.359-8.13-7.359h-80.923
                  c-4.198,0-7.712,3.181-8.13,7.356l-4.491,44.917c-18.741,4.868-36.658,12.3-53.415,22.152l-34.96-28.603
                  c-3.248-2.658-7.983-2.423-10.951,0.546l-57.223,57.224c-2.969,2.969-3.203,7.702-0.546,10.95l28.603,34.96
                  c-9.853,16.755-17.284,34.673-22.152,53.415l-44.917,4.491C3.181,207.826,0,211.341,0,215.538v80.924
                  c0,4.197,3.181,7.713,7.358,8.13l44.917,4.491c4.868,18.741,12.299,36.659,22.152,53.415l-28.603,34.96
                  c-2.657,3.248-2.423,7.983,0.546,10.95l57.222,57.222c2.969,2.969,7.702,3.205,10.951,0.546l34.96-28.603
                  c16.757,9.853,34.673,17.285,53.415,22.152l4.491,44.917c0.418,4.175,3.932,7.356,8.13,7.356h80.923
                  c4.198,0,7.712-3.181,8.13-7.356l4.491-44.917c18.741-4.868,36.658-12.3,53.415-22.152l34.96,28.603
                  c3.247,2.657,7.982,2.422,10.951-0.546l57.222-57.222c2.969-2.969,3.203-7.702,0.546-10.95l-28.603-34.96
                  c9.853-16.755,17.284-34.673,22.152-53.415l44.917-4.491c4.177-0.417,7.358-3.933,7.358-8.13v-80.924
                  C512,211.341,508.819,207.826,504.642,207.408z M495.66,289.068l-43.308,4.331c-3.487,0.349-6.364,2.882-7.149,6.299
                  c-4.817,20.948-13.072,40.855-24.536,59.166c-1.859,2.971-1.617,6.797,0.602,9.509l27.579,33.709l-46.766,46.765l-33.708-27.58
                  c-2.711-2.221-6.538-2.462-9.509-0.601c-18.313,11.463-38.219,19.72-59.167,24.537c-3.416,0.785-5.95,3.661-6.299,7.149
                  l-4.332,43.308h-66.136l-4.331-43.308c-0.349-3.487-2.882-6.364-6.299-7.149c-20.947-4.817-40.854-13.072-59.167-24.537
                  c-2.97-1.861-6.797-1.617-9.509,0.601l-33.708,27.58l-46.766-46.765l27.579-33.709c2.219-2.713,2.462-6.538,0.602-9.509
                  c-11.463-18.311-19.72-38.217-24.536-59.167c-0.786-3.416-3.662-5.95-7.149-6.299l-43.308-4.331v-66.136l43.308-4.331
                  c3.487-0.349,6.364-2.882,7.149-6.299c4.817-20.948,13.072-40.855,24.536-59.167c1.86-2.971,1.617-6.797-0.602-9.509
                  l-27.579-33.709l46.766-46.765l33.708,27.58c2.711,2.22,6.539,2.462,9.509,0.601c18.313-11.463,38.219-19.72,59.167-24.537
                  c3.416-0.785,5.95-3.661,6.299-7.149l4.332-43.306h66.136l4.331,43.308c0.349,3.487,2.882,6.364,6.299,7.149
                  c20.947,4.817,40.854,13.072,59.166,24.537c2.971,1.861,6.797,1.618,9.509-0.601l33.708-27.581l46.766,46.765l-27.579,33.709
                  c-2.219,2.713-2.462,6.538-0.602,9.509c11.463,18.311,19.72,38.217,24.536,59.167c0.786,3.416,3.662,5.95,7.149,6.299
                  l43.307,4.331V289.068z"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M256.002,171.575c-46.552,0-84.426,37.873-84.426,84.426s37.874,84.426,84.426,84.426
                  c46.552,0,84.426-37.873,84.426-84.426S302.554,171.575,256.002,171.575z M323.58,247.83h-34.136
                  c-0.715-20.686-4.154-41.364-10.591-55.958C302.719,200.403,320.462,221.895,323.58,247.83z M233.159,191.87
                  c-6.44,14.595-9.884,35.27-10.599,55.961h-34.135C191.542,221.893,209.288,200.398,233.159,191.87z M188.425,264.171h34.135
                  c0.715,20.692,4.16,41.366,10.603,55.962C209.289,311.605,191.542,290.11,188.425,264.171z M266.224,307.338
                  c-4.589,13.767-9.302,16.748-10.223,16.748c-0.921,0-5.633-2.98-10.223-16.748c-3.891-11.674-6.276-26.774-6.873-43.167h34.191
                  C272.499,280.563,270.116,295.664,266.224,307.338z M238.908,247.83c0.597-16.393,2.981-31.493,6.873-43.167
                  c4.588-13.767,9.301-16.748,10.222-16.748c0.92,0,5.633,2.98,10.223,16.748c3.891,11.674,6.276,26.774,6.873,43.167H238.908z
                  M278.849,320.13c6.439-14.594,9.881-35.271,10.595-55.959h34.135C320.462,290.107,302.718,311.6,278.849,320.13z"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M256.002,77.89c-44.587,0-87.251,16.556-120.134,46.619c-32.668,29.866-52.966,70.484-57.154,114.373
                  c-0.429,4.491,2.865,8.481,7.356,8.91c4.521,0.431,8.482-2.865,8.91-7.358c7.955-83.35,77.179-146.204,161.022-146.204
                  c89.2,0,161.77,72.57,161.77,161.77s-72.57,161.77-161.77,161.77c-83.845,0-153.069-62.856-161.022-146.208
                  c-0.428-4.492-4.432-7.785-8.909-7.358c-4.493,0.429-7.786,4.417-7.358,8.91c4.188,43.889,24.484,84.509,57.152,114.376
                  c32.885,30.063,75.549,46.62,120.136,46.62c98.21,0,178.111-79.9,178.111-178.111S354.213,77.89,256.002,77.89z"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M256.002,138.894c-25.202,0-49.22,7.89-69.452,22.818c-3.632,2.679-4.403,7.793-1.724,11.425
                  c2.68,3.632,7.794,4.404,11.424,1.724c17.405-12.839,38.066-19.626,59.753-19.626c55.563,0,100.766,45.203,100.766,100.766
                  c0,55.563-45.203,100.766-100.766,100.766s-100.766-45.203-100.766-100.766c0-21.688,6.787-42.351,19.629-59.756
                  c2.678-3.632,1.906-8.746-1.724-11.425c-3.633-2.679-8.745-1.907-11.425,1.723c-14.929,20.234-22.82,44.252-22.82,69.457
                  c0,64.573,52.534,117.106,117.106,117.106c64.572,0,117.106-52.533,117.106-117.106S320.574,138.894,256.002,138.894z"
              />
            </g>
          </g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
        </svg>
        <h2>Plataformas</h2>
        <p>
          Criamos uma base de dados repleta de exercicios , frequencias e exames
          com as suas devidas soluções e explicações, para que possas levar o
          teu estudo ao próximo nivel!
        </p>
      </div>
      <div class="workshops">
        <svg
          version="1.1"
          :width="width"
          :height="height"
          id="Layer_1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 512 512"
          style="enable-background:new 0 0 512 512;"
          xml:space="preserve"
        >
          <path
            style="fill:#25B6D2;"
            d="M0,260.908l174.648-81.136v38.568l-132.08,57.848v0.728l132.08,57.848v38.568L0,292.212V260.908z"
          />
          <path
            style="fill:#415E72;"
            d="M201.6,387.9l77.864-263.8h36.752L238.4,387.9H201.6z"
          />
          <path
            style="fill:#E04F5F;"
            d="M512,293.284L337.352,373.34v-38.568l134.992-57.848v-0.728L337.352,218.34v-38.568L512,259.828
              V293.284z"
          />
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
        </svg>
        <h2>Workshops</h2>
        <p>workshops tecnologias emergentes</p>
      </div>
    </div>
  </section>
  <section class="ourWork">
    <div class="work">
      <div class="text">
        <h1>Como podes ajudar?</h1>
        <p>
          Tendo como objectivo apoiar os alunos do departamento de informática
          da Universidade de Évora, contamos com a tua ajuda para melhorar esta
          comunidade!
        </p>
        <div class="events">
          <EventCard
            class="firstEvent"
            titulo="Voz"
            descricao="Torna-te uma voz ativa dentro da comunidade! Contamos com toda a ajuda que podemos ter pois projetos e ideias não faltam!"
          >
            <svg
              version="1.1"
              :width="width"
              :height="height"
              id="Layer_1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              x="0px"
              y="0px"
              viewBox="0 0 512 512"
              style="enable-background:new 0 0 512 512;"
              xml:space="preserve"
            >
              <path
                style="fill:#EFF2FA;"
                d="M427.809,199.138c-55.876-7.203-103.887,33.141-109.398,86.122c-0.178,1.705-0.822,3.331-1.92,4.649
                  l-27.975,33.57c-2.396,2.874-0.351,7.24,3.391,7.24h26.82c3.514,0,6.583,2.137,8.056,5.327
                  c15.382,33.314,49.01,56.466,88.113,56.466c57.367,0,103.115-49.747,96.458-108.456
                  C506.406,240.404,471.379,204.755,427.809,199.138z"
              />
              <path
                style="fill:#694B4B;"
                d="M264.828,136.51h-88.276H88.276c-8.828,8.828-10.814,36.137-8.491,50.652l6.02,37.624h90.746h90.748
                  l6.02-37.624C275.641,172.647,273.655,145.337,264.828,136.51z"
              />
              <path
                style="fill:#5A4146;"
                d="M187.421,185.463l82.732-21.02c1.204-0.306,2.323-0.778,3.447-1.24
                  c-1.1-11.028-3.835-21.757-8.771-26.694h-88.276H88.276c-8.828,8.828-10.814,36.137-8.491,50.652l6.02,37.624h90.746v-37.964
                  C180.214,186.823,183.871,186.365,187.421,185.463z"
              />
              <path
                style="fill:#464655;"
                d="M327.939,384.961l-64.643-19.485H90.223l-65.059,19.485C10.229,389.442,0,403.189,0,418.782v35.521
                  c0,9.75,7.905,17.655,17.655,17.655h317.793c9.75,0,17.655-7.905,17.655-17.655v-35.521
                  C353.103,403.189,342.874,389.442,327.939,384.961z"
              />
              <polygon
                style="fill:#D29B6E;"
                points="238.345,304.235 238.345,353.523 176.552,403.862 114.759,353.523 114.759,304.235 "
              />
              <g>
                <path
                  style="fill:#5B5D6E;"
                  d="M252.349,347.308c-2.812-4.216-8.587-5.206-12.642-2.165l-63.155,47.367l-63.155-47.367
                    c-4.054-3.041-9.831-2.051-12.642,2.165l-12.479,18.719l38.719,54.207c2.944,4.121,8.744,4.926,12.697,1.762l20.861-16.689
                    c2.89-2.312,7.171-0.255,7.171,3.446v63.203h17.655v-63.203c0-3.701,4.281-5.759,7.171-3.446l20.861,16.689
                    c3.955,3.164,9.754,2.359,12.697-1.762l38.719-54.207L252.349,347.308z"
                />
                <path
                  style="fill:#5B5D6E;"
                  d="M52.264,428.707l-41.939-34.828C3.885,400.344,0,409.203,0,418.782v35.521
                    c0,9.75,7.905,17.655,17.655,17.655h44.138v-22.906C61.793,441.192,58.302,433.739,52.264,428.707z"
                />
                <path
                  style="fill:#5B5D6E;"
                  d="M353.103,454.303v-35.521c0-9.611-3.907-18.503-10.386-24.973l-41.878,34.899
                    c-6.038,5.032-9.529,12.484-9.529,20.344v22.906h44.138C345.198,471.958,353.103,464.054,353.103,454.303z"
                />
              </g>
              <path
                style="fill:#59D8FF;"
                d="M414.897,366.027c-38.94,0-70.621-31.681-70.621-70.621s31.681-70.621,70.621-70.621
                  s70.621,31.681,70.621,70.621c0,17.341-7.319,31.021-20.086,37.59c-10.422,5.366-23.155,4.888-31.699-1.219
                  c-2.379-1.703-4.337-3.737-5.818-6.03c-1.802,1.366-3.715,2.612-5.732,3.715c-9.362,5.142-19.345,6.216-27.362,2.922
                  c-7.914-3.242-13.775-9.495-16.509-17.608c-3.353-9.974-1.492-21.771,5.259-33.228c7.086-12.052,16.276-20.116,27.31-23.975
                  c8.785-3.073,18.354-1.28,25.621,4.798c7.491,6.268,11.19,16.104,9.655,25.677l-1.845,11.534c-0.018,0.104-0.034,0.207-0.052,0.31
                  l-2.069,12.927c-0.301,2.06,0.233,3.47,1.802,4.59c2.733,1.949,8.199,2.548,13.362-0.113c6.776-3.487,10.508-11.242,10.508-21.832
                  c0-29.267-23.758-53.026-52.966-53.026c-29.207,0-52.966,23.758-52.966,52.966c0,29.207,23.758,52.966,52.966,52.966
                  c2.526,0,5.078-0.181,7.595-0.538c4.802-0.719,9.293,2.673,9.983,7.5c0.681,4.828-2.673,9.298-7.5,9.983
                  C421.638,365.787,418.25,366.027,414.897,366.027z M419.482,273.756c-0.862,0-1.793,0.138-2.776,0.483
                  c-7.078,2.478-12.94,7.797-17.931,16.267c-4.104,6.974-5.431,13.594-3.733,18.638c1.069,3.181,3.371,5.633,6.465,6.905
                  c2.974,1.219,7.647,0.423,12.181-2.065c6.871-3.767,11.905-10.306,13.173-17.086l1.863-11.642c0.561-3.518-0.767-7.009-3.552-9.341
                  C424.276,275.166,422.225,273.756,419.482,273.756z"
              />
              <path
                style="fill:#F0C087;"
                d="M264.828,215.958H254.41c-4.207,0-7.831-2.97-8.657-7.096l-4.57-22.849
                  c-1.651-8.253-8.896-14.193-17.312-14.193h-94.639c-8.416,0-15.661,5.94-17.312,14.193l-4.57,22.849
                  c-0.825,4.126-4.448,7.096-8.657,7.096H88.276c-9.75,0-17.655,7.904-17.655,17.655v17.655c0,9.75,7.905,17.655,17.655,17.655h4.59
                  l2.145,13.41c1.348,8.428,5.705,16.083,12.262,21.547l35.43,29.524c4.759,3.966,10.759,6.138,16.953,6.138h33.79
                  c6.195,0,12.194-2.173,16.953-6.138l35.43-29.524c6.557-5.464,10.913-13.119,12.262-21.547l2.145-13.41h4.593
                  c9.75,0,17.655-7.905,17.655-17.655v-17.655C282.483,223.862,274.578,215.958,264.828,215.958z"
              />
              <path
                style="fill:#E6AF78;"
                d="M150.069,277.983v-79.679c0-4.875,3.953-8.828,8.828-8.828h82.979l-0.692-3.462
                  c-1.65-8.253-8.896-14.194-17.312-14.194h-94.639c-8.416,0-15.661,5.94-17.312,14.193l-4.57,22.849
                  c-0.825,4.126-4.448,7.096-8.657,7.096H88.276c-9.751,0-17.655,7.904-17.655,17.655v17.655c0,9.751,7.904,17.655,17.655,17.655h4.59
                  l2.145,13.41c1.348,8.428,5.704,16.083,12.262,21.547l35.432,29.526c4.759,3.966,10.758,6.137,16.952,6.137h8.067l-14.937-44.811
                  C150.987,289.332,150.069,283.676,150.069,277.983z"
              />
              <rect
                x="308.966"
                y="74.715"
                style="fill:#464655;"
                width="17.655"
                height="79.448"
              />
              <path
                style="fill:#5B5D6E;"
                d="M89.743,83.544l-8.968,53.782c-0.755,4.527,2.086,8.878,6.534,10.008l82.722,21.017
                  c4.279,1.087,8.764,1.087,13.043,0l82.732-21.02c4.442-1.129,7.279-5.474,6.526-9.995l-8.97-53.792H89.743V83.544z"
              />
              <path
                style="fill:#464655;"
                d="M183.722,126.702l84.152-16.086l0,0l-4.514-27.072H89.743l-8.968,53.782
                  c-0.755,4.527,2.086,8.877,6.534,10.008l82.721,21.017c2.14,0.544,4.33,0.815,6.521,0.815v-33.793
                  C176.552,131.137,179.561,127.498,183.722,126.702z"
              />
              <path
                style="fill:#707487;"
                d="M170.004,40.665L12.26,70.711c-4.419,0.842-4.419,7.169,0,8.011l157.743,30.046
                  c4.365,0.832,8.849,0.832,13.214,0l157.743-30.046c4.419-0.842,4.419-7.169,0-8.011L183.218,40.665
                  C178.852,39.833,174.369,39.833,170.004,40.665z"
              />
              <path
                style="fill:#5B5D6E;"
                d="M317.793,145.337L317.793,145.337c-9.751,0-17.655,7.904-17.655,17.655v26.483
                  c0,4.875,3.953,8.828,8.828,8.828h17.655c4.875,0,8.828-3.953,8.828-8.828v-26.483C335.448,153.243,327.544,145.337,317.793,145.337
                  z"
              />
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
            </svg>
          </EventCard>
          <EventCard
            titulo="Entreajuda"
            descricao="Partilha as tuas dúvidas junto dos teus colegas, a humildade e a ajuda é a essência para uma carreira de sucesso"
          >
            <svg
              version="1.1"
              id="Layer_1"
              :width="width"
              :height="height"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              x="0px"
              y="0px"
              viewBox="0 0 508 508"
              style="enable-background:new 0 0 508 508;"
              xml:space="preserve"
            >
              <circle style="fill:#324A5E;" cx="254" cy="254" r="254" />
              <path
                style="fill:#F9B54C;"
                d="M421.2,317.6l-10.4-14.4c-12-16.8-26-32-42-45.2L332,226c-4.8-4.4-12.4-3.6-16.4,1.6
                  c-3.6,4.8-2.8,11.6,1.6,15.6l28.4,23.6c0.4,0.4,0.4,1.2,0,1.6s-1.2,0.4-2,0L298,230.8c-4-3.2-10-4-14-1.2c3.2-4,3.6-9.6,0.4-14l0,0
                  c0-0.4-0.4-0.4-0.8-0.8c-4-4.4-11.2-4.8-16-1.2l-60,42.4c-0.4,0.4-1.2,0.4-1.6-0.4c-0.4-0.4-0.4-1.2,0.4-1.6l54.4-38.8
                  c5.6-4,6.8-12,2.8-17.6c-4-5.2-11.2-6.4-16.8-2.8L184,238.4c7.2-12,12-24.8,10.8-36c-0.4-5.6-8-8.4-13.6-6.4
                  c-2.4,0.8-5.2,2.8-6.8,6.4c0,0-2,17.2-24.8,30.8c-23.2,13.6-29.2,56.8-29.2,56.8c-3.6,16-53.2,49.2-53.2,49.2l38.4,50
                  c23.2-15.2,62-29.6,62-29.6l16.8-6.4c19.2-7.2,37.6-16.8,54.8-28.4l28-19.2l33.2,28c-13.6-4-27.2-4.8-37.6-0.8c-5.2,2-6,10-2.8,14.8
                  c1.2,2,4,4.4,8,5.2c0,0,17.2-2.4,36.4,16c19.2,18.4,62.4,13.2,62.4,13.2c16.4-0.8,61.2,38.4,61.2,38.4l38.4-50
                  C445.6,351.2,421.2,317.6,421.2,317.6z M235.6,300c-0.4,0.4-1.2,0.4-1.6-0.4c-0.4-0.4,0-1.2,0.4-1.6l12.8-9.2l2,1.6L235.6,300z
                  M225.6,274.8c-0.4,0.4-1.2,0.4-1.6-0.4c-0.4-0.4-0.4-1.2,0.4-1.6l26.8-18.8c0.4,0.8,0.8,1.6,1.2,2L225.6,274.8z M311.2,307.6
                  c-0.4,0.4-1.2,0.4-1.6,0L284,286.8c-0.4-2-0.8-3.6-2-5.2l29.2,24.4C311.6,306,311.6,306.8,311.2,307.6z M324.8,285.2
                  c-0.4,0.4-1.2,0.4-1.6,0L288,256c0.4-0.8,0.4-2,0.4-3.2l36.4,30.4C325.2,284,325.2,284.8,324.8,285.2z"
              />
              <path
                style="fill:#FF7058;"
                d="M18,348c12.8,32.4,32.4,61.6,56.4,85.6l76.8-48.8l-52-88.4L18,348z"
              />
              <path
                style="fill:#4CDBC4;"
                d="M450,326.4L378.4,400l46.4,42c25.6-23.2,46.4-51.6,60.8-83.6L450,326.4z"
              />
              <path
                style="fill:#FFD05B;"
                d="M220.8,255.6c6-0.4,10.8-5.6,10.8-11.6l-0.8-36.8c0-0.8,0.4-1.2,1.2-1.2s1.2,0.4,1.2,1.2l1.6,58.8
                  c0,6,4.4,11.2,10,12c7.2,0.8,13.6-4.8,13.2-12l-1.2-53.6c0-0.8,0.4-1.2,1.2-1.2c0.8,0,1.2,0.4,1.2,1.2l1.6,70c0,6.8,5.6,12,12.4,12
                  l0,0c0.4,0,0.8,0,1.2,0c6-1.2,10-6.8,10-12.8l-2-73.6c0-0.8,0.4-1.2,1.2-1.2c0.8,0,1.2,0.4,1.2,1.2l2,66.8c0,6.8,6,12.4,13.2,12
                  c6.4-0.4,11.6-6,11.6-12.4l-1.2-76c6,12.8,14,23.6,24,28.8c5.2,2.8,11.2-2,12.8-7.6c0.8-2.4,0.4-6-1.6-9.2c0,0-13.2-11.6-12-38
                  s-31.2-55.6-31.2-55.6c-11.2-12-11.6-71.2-11.6-71.2l-62.8,4c0,27.6-9.6,68-9.6,68l-4,17.6c-4.4,20-6.8,40.8-6.8,61.2l0.4,48.4
                  C208.8,250.8,214.4,256,220.8,255.6z"
              />
              <path
                style="fill:#E6E9EE;"
                d="M311.2,6.4C292.8,2.4,273.6,0,254,0c-15.6,0-30.8,1.6-45.2,4l-1.6,85.6l102.4,5.6L311.2,6.4z"
              />
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
            </svg>
          </EventCard>
          <EventCard
            class="thirdEvent"
            titulo="Ideias"
            descricao="Liberta o teu espirito empreendedor e junta-te com os teus colegas para darem vida a novos projetos que podem mudar o mundo"
          >
            <svg
              version="1.1"
              :width="width"
              :height="height"
              id="Layer_1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              x="0px"
              y="0px"
              viewBox="0 0 503.19 503.19"
              style="enable-background:new 0 0 503.19 503.19;"
              xml:space="preserve"
            >
              <path
                style="fill:#1E74A5;"
                d="M458.101,292.8c-4.8-8-19.2-40.8-30.4-66.4c4-14.4,5.6-29.6,5.6-44.8c0-100.8-84-181.6-180-181.6
              s-190.4,109.6-157.6,204.8c14.4,42.4,25.6,73.6,36.8,96.8l-60,100.8c-10.4,20.8,11.2,37.6,32,48l80,41.6
              c20.8,10.4,55.2,19.2,65.6-0.8l42.4-77.6c29.6,12.8,57.6,19.2,80,18.4c23.2-1.6,31.2-25.6,36-60c4.8,0,10.4,0,13.6-4.8
              c4.8-8.8-7.2-21.6-7.2-21.6s20-5.6,15.2-11.2c-4-4-7.2-21.6-8-26.4c7.2,0,16-0.8,24-3.2C465.301,299.2,458.101,292.8,458.101,292.8z
              "
              />
              <path
                style="fill:#074568;"
                d="M458.101,292.8c-4.8-8-24-24.8-35.2-49.6c4-14.4,10.4-45.6,10.4-60.8c0-101.6-82.4-154.4-178.4-154.4
              s-191.2,82.4-158.4,177.6c14.4,42.4,25.6,73.6,36.8,96.8l-60.8,100c-10.4,20.8,11.2,37.6,32,48l80,41.6
              c20.8,10.4,55.2,19.2,65.6-0.8l7.2-102.4c28.8,31.2,92.8,44,115.2,43.2c23.2-1.6,31.2-25.6,36-60c4.8,0,10.4,0,13.6-4.8
              c4.8-8.8-20-17.6-20-17.6s32.8-9.6,28.8-15.2c-4-4-18.4-20.8-19.2-26.4c7.2,0,27.2-1.6,35.2-4
              C465.301,299.2,458.101,292.8,458.101,292.8z"
              />
              <path
                style="fill:#FFE000;"
                d="M302.901,140c0-61.6-58.4-111.2-129.6-111.2c-71.2,0-129.6,50.4-129.6,111.2c0,36,20,68,51.2,88
              l10.4,43.2c0,34.4,28,60.8,61.6,60.8h13.6c34.4,0,61.6-26.4,61.6-60.8l10.4-44C282.901,207.2,302.901,176,302.901,140z"
              />
              <path
                style="fill:#FFC200;"
                d="M302.901,140c0-61.6-58.4-93.6-129.6-93.6s-129.6,32.8-129.6,93.6c0,36,28.8,59.2,59.2,79.2l1.6,52
              c0,34.4,28,60.8,61.6,60.8h13.6c34.4,0,61.6-26.4,61.6-60.8l1.6-52C274.901,198.4,302.901,176,302.901,140z"
              />
              <path
                style="fill:#4396BF;"
                d="M104.501,273.6v35.2c0,37.6,30.4,68.8,68.8,68.8c37.6,0,68.8-30.4,68.8-68.8v-35.2H104.501
              L104.501,273.6z"
              />
              <path
                style="fill:#1E74A5;"
                d="M104.501,308.8c0,37.6,30.4,68.8,68.8,68.8c37.6,0,68.8-30.4,68.8-68.8"
              />
              <g>
                <path
                  style="fill:#F9F4BD;"
                  d="M173.301,272c-2.4,0-4-1.6-4-4v-89.6c0-0.8-0.8-59.2-36.8-67.2c-7.2-1.6-12,0-16,4
                c-6.4,7.2-6.4,20.8-1.6,34.4c5.6,16,17.6,26.4,32.8,30.4v-20c0-2.4,1.6-4,4-4s4,1.6,4,4v24.8c0,1.6-0.8,2.4-1.6,3.2
                s-2.4,0.8-3.2,0.8c-20-2.4-36.8-16.8-44-36.8c-6.4-16.8-4.8-33.6,3.2-43.2c5.6-6.4,14.4-8.8,24-6.4c43.2,9.6,44,72.8,44,76V268
                C177.301,270.4,175.701,272,173.301,272z"
                />
                <path
                  style="fill:#F9F4BD;"
                  d="M173.301,272c2.4,0,4-1.6,4-4v-89.6c0-0.8,0.8-59.2,36.8-67.2c7.2-1.6,12,0,16,4
                c6.4,7.2,6.4,20.8,1.6,34.4c-5.6,16-17.6,26.4-32.8,30.4v-20c0-2.4-1.6-4-4-4s-4,1.6-4,4v24.8c0,1.6,0.8,2.4,1.6,3.2
                s2.4,0.8,3.2,0.8c20-2.4,36.8-16.8,44-36.8c6.4-16.8,4.8-33.6-3.2-43.2c-5.6-6.4-14.4-8.8-24-6.4c-43.2,9.6-44,72.8-44,76V268
                C169.301,270.4,170.901,272,173.301,272z"
                />
                <path
                  style="fill:#F9F4BD;"
                  d="M186.901,207.2c0,1.6-1.6,3.2-3.2,3.2h-20c-1.6,0-3.2-1.6-3.2-3.2l0,0c0-1.6,1.6-3.2,3.2-3.2h20
                C185.301,203.2,186.901,204.8,186.901,207.2L186.901,207.2z"
                />
                <path
                  style="fill:#F9F4BD;"
                  d="M186.901,224c0,1.6-1.6,3.2-3.2,3.2h-20c-1.6,0-3.2-1.6-3.2-3.2l0,0c0-1.6,1.6-3.2,3.2-3.2h20
                C185.301,220.8,186.901,222.4,186.901,224L186.901,224z"
                />
                <path
                  style="fill:#F9F4BD;"
                  d="M186.901,240.8c0,1.6-1.6,3.2-3.2,3.2h-20c-1.6,0-3.2-1.6-3.2-3.2l0,0c0-1.6,1.6-3.2,3.2-3.2h20
                C185.301,237.6,186.901,239.2,186.901,240.8L186.901,240.8z"
                />
                <circle style="fill:#F9F4BD;" cx="173.301" cy="83.2" r="5.6" />
              </g>
              <g>
                <path
                  style="fill:#6FCAEF;"
                  d="M234.901,290.4c0,0.8-0.8,1.6-1.6,1.6h-119.2c-0.8,0-1.6-0.8-1.6-1.6l0,0c0-0.8,0.8-1.6,1.6-1.6
                h119.2C234.101,288.8,234.901,289.6,234.901,290.4L234.901,290.4z"
                />
                <path
                  style="fill:#6FCAEF;"
                  d="M234.901,302.4c0,0.8-0.8,1.6-1.6,1.6h-119.2c-0.8,0-1.6-0.8-1.6-1.6l0,0c0-0.8,0.8-1.6,1.6-1.6
                h119.2C234.101,300.8,234.901,301.6,234.901,302.4L234.901,302.4z"
                />
                <path
                  style="fill:#6FCAEF;"
                  d="M234.901,314.4c0,0.8-0.8,1.6-1.6,1.6h-119.2c-0.8,0-1.6-0.8-1.6-1.6l0,0c0-0.8,0.8-1.6,1.6-1.6
                h119.2C234.101,312.8,234.901,313.6,234.901,314.4L234.901,314.4z"
                />
                <path
                  style="fill:#6FCAEF;"
                  d="M234.901,327.2c0,0.8-0.8,1.6-1.6,1.6h-119.2c-0.8,0-1.6-0.8-1.6-1.6l0,0c0-0.8,0.8-1.6,1.6-1.6
                h119.2C234.101,325.6,234.901,325.6,234.901,327.2L234.901,327.2z"
                />
                <path
                  style="fill:#6FCAEF;"
                  d="M226.101,339.2c0,0.8-0.8,1.6-1.6,1.6h-102.4c-0.8,0-1.6-0.8-1.6-1.6l0,0c0-0.8,0.8-1.6,1.6-1.6
                h103.2C226.101,337.6,226.101,338.4,226.101,339.2L226.101,339.2z"
                />
                <circle style="fill:#6FCAEF;" cx="146.901" cy="354.4" r="2.4" />
                <circle style="fill:#6FCAEF;" cx="164.501" cy="354.4" r="2.4" />
                <circle style="fill:#6FCAEF;" cx="182.101" cy="354.4" r="2.4" />
                <circle style="fill:#6FCAEF;" cx="199.701" cy="354.4" r="2.4" />
              </g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
            </svg>
          </EventCard>
        </div>
      </div>
      <img src="@/assets/placeholder.jpg" alt="" />
    </div>
  </section>
  <section class="recrutamento">
    <div class="aboutUs">
      <img src="@/assets/team.jpg" alt="" />
      <div class="text">
        <h1>Quem somos?</h1>
        <p>
          Somos uma equipa composta por alunos voluntários que representa e
          promove o curso a toda a comunidade académica
        </p>
        <p>
          Podes-nos encontrar na sala do NEEI ou em qualquer uma das redes
          sociais!
        </p>
        <p>
          Já nao sabia o que fazer aqui mas acho que depois ter um botão que dá
          para uma pagina da equipa com tudo organizado era fixe! Sessão de
          brainstorm para a semana no NEEI?
        </p>
        <button class="teamButton"><i class="fas fa-chevron-right"></i></button>
      </div>
    </div>
  </section>
  <section class="noticias">
    <div class="noticiasPreview">
      <h1>Notícias</h1>
      <div class="carrossel">
        <NoticiaCard
          v-for="noticia in noticias"
          :key="noticia.id"
          :imgURL="getImgURL(noticia.imgURL)"
          :titulo="noticia.titulo"
          :data="noticia.dataDePublicacao"
          :textPreview="noticia.textPreview"
        />
      </div>
    </div>
  </section>
  <section class="contactos">
    <h1>Tens alguma dúvida? Contacta-nos!</h1>
    <div class="quickContacts subtitle">
      <div class="socials">
        <a
          class="icon"
          id="facebook"
          href="hhttps://www.facebook.com/neeiue"
          target="_blank"
          ><i class="fab fa-facebook-square"></i
        ></a>
        <a
          class="icon"
          id="instagram"
          href="https://www.instagram.com/neeiue/"
          target="_blank"
          ><i class="fab fa-instagram-square"></i
        ></a>
        <a
          class="icon"
          id="linkedin"
          href="https://www.linkedin.com/company/neei-ue/"
          target="_blank"
          ><i class="fab fa-linkedin"></i
        ></a>
        <a
          class="icon"
          id="github"
          href="https://github.com/NEEI-UEvora"
          target="_blank"
          ><i class="fab fa-github-square"></i
        ></a>
      </div>
      <p>Rua Romão Ramalho Nº59, 7000-671 Évora, Portugal</p>
    </div>
    <div class="contact">
      <img class="contactImage" src="@/assets/contact.svg" alt="" />
      <form @submit.prevent="handleSubmit">
        <label for="Nome">Nome</label>
        <input type="text" placeholder="Nome" required v-model="nome" />
        <label for="Email">Email</label>
        <input type="email" placeholder="Email" required v-model="email" />
        <label for="Assunto">Assunto</label>
        <input type="text" placeholder="Assunto" required v-model="assunto" />
        <label for="Mensagem">Mensagem</label>
        <textarea required v-model="mensagem" />
        <button :class="{ sucess: sucessButton }">Enviar mensagem</button>
      </form>
    </div>
  </section>
  <Footer />
</template>

<script>
import ScrollToTopButton from "@/components/ScrollToTopButton.vue";
import Navbar from "@/components/Navbar.vue";
import EventCard from "@/components/EventCard.vue";
import NoticiaCard from "@/components/NoticiaCard.vue";
import Footer from "@/components/Footer.vue";

export default {
  name: "Home",
  data() {
    return {
      height: "50px",
      width: "50px",
      isAtTop: true,
      noticias: [
        {
          id: 0,
          category: "any",
          imgURL: "catita.jpg",
          titulo: "NEEI nomeia o jovem mais catita do curso",
          dataDePublicacao: "6 Maio, 2021",
          textPreview:
            "Após um fim de semana de competição inédito, o voto foi decido pelo jurado Massas, que deu ao candidato uma pontuação de 10/10 , coroando assim o estudante Miguel Portugal como o jovem mais catita do curso de Engenharia Informática",
        },
        {
          id: 1,
          category: "any",
          imgURL: "team.jpg",
          titulo: "Equipa do NEEI finalmente chega a Coimbra",
          dataDePublicacao: "3 Março, 2020",
          textPreview:
            "Partindo de Évora, a equipa do NEEI partiu rumo ao ENEI 2020 em Braga, sempre com a questão em mente...Será desta que chegam a Coimbra para celebrarem o aniversário do Fox? Não perca o próximo episodio, porque nós também não!",
        },
        {
          id: 2,
          category: "any",
          imgURL: "ctf.jpg",
          titulo: "NEEI organiza CTF",
          dataDePublicacao: "2 Janeiro, 1999",
          textPreview:
            "A equipa do NEEI organizou na passada terça feira O desafio para testarem os vossos skills de Hackerman, és capaz de fazer frente ao nosso Mr.Robot?",
        },
      ],
      nome: "",
      email: "",
      assunto: "",
      mensagem: "",
      sucessButton: false,
    };
  },
  components: {
    ScrollToTopButton,
    Navbar,
    EventCard,
    NoticiaCard,
    Footer,
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
    this.handleResize();
    window.addEventListener("resize", this.handleResize);
  },
  unmounted() {
    window.removeEventListener("scroll", this.handleScroll);
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    scrollToElement(destination) {
      const element = document.querySelector(destination);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    },
    getImgURL(image) {
      return require("../assets/" + image);
    },
    handleScroll() {
      window.pageYOffset >= 250
        ? (this.isAtTop = false)
        : (this.isAtTop = true);
    },
    handleResize() {
      this.mobileMode = window.innerWidth <= 1015;
      if (!this.mobileMode) {
        this.activatedNavbar = false;
      }
    },
    handleSubmit() {
      console.log(
        this.nome +
          " " +
          this.assunto +
          " " +
          this.email +
          " " +
          this.mensagem +
          " "
      );
      this.sucessButton = true;
      setInterval(() => {
        this.nome = "";
        this.assunto = "";
        this.email = "";
        this.mensagem = "";
        this.sucessButton = false;
      }, 3000);
    },
  },
};
</script>

<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css2?family=Poppins:wght@300&display=swap");

// Colors

$informaticaBlue: #1935a1;
$informaticaLightBlue: lighten(
  $color: $informaticaBlue,
  $amount: 62%,
);
$mirtiloAzul: lighten(
  $color: $informaticaBlue,
  $amount: 40%,
);

// Font size

$textFontSize: 16px;
$h1FontSize: 48px;

body {
  font-family: "Poppins", sans-serif;
  min-width: 100%;
}

p {
  -webkit-hyphens: auto;
  -ms-hyphens: auto;
  hyphens: auto;
}

section {
  padding: 20px 30px 20px 30px;
}

.heroContent {
  height: 100vh;
  width: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  overflow: hidden;
  max-width: 100%;
  .textArea {
    display: flex;
    width: 40%;
    justify-content: left;
    align-items: left;
    flex-direction: column;
    margin-left: 40px;
    .slogan {
      font-size: 2.5vw;
      margin: 10px 0px;
      text-transform: uppercase;
    }

    .heroText {
      width: 85%;
    }

    button {
      max-width: 300px;
      position: relative;
      display: inline-block;
      text-align: center;
      text-transform: uppercase;
      padding: 15px;
      margin: 30px 25px 0 0;
      font-size: 100% + 10%;
      font-weight: 600;
      border-radius: 5px;
      border: none;
      color: $informaticaBlue;
      background-color: white;
      transition: all 0.5s;
      &::before {
        position: absolute;
        content: "";
        border-radius: 5px;
        border-top: 5px solid lighten($informaticaBlue, 5%);
        border-left: 5px solid lighten($informaticaBlue, 5%);
        border-right: 5px solid darken($informaticaBlue, 5%);
        border-bottom: 5px solid darken($informaticaBlue, 5%);
        top: 0px;
        right: 0px;
        bottom: 0px;
        left: 0px;
        transition: 0.5s;
      }
      &:hover {
        box-shadow: 7px 7px darken($informaticaBlue, 10%),
          -7px -7px lighten($informaticaBlue, 10%);
        background-color: $informaticaBlue;
        color: #f7f7f7;
        cursor: pointer;
        &::before {
          border: 0px;
        }
      }
    }
    .socio {
      background: #f7f7f7;
      color: $informaticaBlue;
    }
    .socio:hover {
      box-shadow: 7px 7px darken($informaticaBlue, 10%),
        -7px -7px lighten($informaticaBlue, 10%);
      background-color: $informaticaBlue;
      color: #f7f7f7;
      cursor: pointer;
    }
  }
  .heroImage {
    width: 48%;
    overflow-x: none;
  }
}

.features {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background-color: $informaticaLightBlue;

  h1 {
    font-size: $h1FontSize;
    margin-bottom: 20px;
  }

  .subtitle {
    text-align: center;
    margin-top: 0;
    margin-bottom: 100px;
    width: 50%;
  }

  .feature {
    display: flex;
    justify-content: center;
    align-items: center;

    div {
      width: 20%;
      height: 300px;
      display: flex;
      align-items: center;
      flex-direction: column;
      margin: 20px 30px 20px 30px;
      padding: 10px;
    }
  }
}

.ourWork {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  .work {
    display: flex;

    img {
      width: 40%;
      border-radius: 6px;
    }

    .events {
      display: flex;
      height: 60%;
    }

    .firstEvent {
      border-right: 1px solid #c5c5c5;
    }

    .thirdEvent {
      border-left: 1px solid #c5c5c5;
    }

    .text {
      display: flex;
      flex-direction: column;
      margin-right: 30px;

      h1 {
        margin: 0;
        font-size: $h1FontSize;
        margin-bottom: 25px;
      }

      p {
        margin-bottom: 70px;
      }
    }
  }
}
.recrutamento {
  padding: 20px;
  height: 100vh;
  background-color: $informaticaLightBlue;
  .aboutUs {
    display: flex;
    img {
      border-radius: 6px;
      margin-right: 30px;
      width: 40%;
    }
    .text {
      display: flex;
      flex-direction: column;
      justify-content: end;
      h1 {
        font-size: $h1FontSize;
      }

      .teamButton {
        height: 60px;
        width: 60px;
        background-color: $informaticaBlue;
        border: none;
        border-radius: 50%;

        &:hover {
          cursor: pointer;

          i {
            transform: translateX(3px);
          }
        }

        i {
          font-size: 30px;
          color: $informaticaLightBlue;
          transition: transform 0.2s cubic-bezier(0.075, 0.82, 0.165, 1);
        }
      }
    }
  }
}

.noticias {
  h1 {
    font-size: 80px;
  }
  .noticiasPreview {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .carrossel {
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
    }
  }
}

.contactos {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: $informaticaLightBlue;

  h1 {
    font-size: $h1FontSize;
    margin-bottom: 20px;
  }

  .subtitle {
    text-align: center;
    margin-top: 0;
    margin-bottom: 20px;
    width: 50%;
  }

  .quickContacts {
    display: flex;
    justify-content: center;
    align-items: center;

    .socials:nth-last-child(2) {
      border-right: 1px solid #c5c5c5;
    }

    i {
      cursor: pointer;
      font-size: 30px;
      padding-right: 10px;
      color: rgb(56, 56, 56);
      transition: color 0.2s ease-in;

      &:hover {
        color: $informaticaBlue;
      }
    }

    p {
      margin-left: 10px;
    }
  }
  .contact {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;

    .contactImage {
      width: 40%;
    }

    form {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: 50%;

      label {
        width: 60%;
        margin-bottom: 5px;
        font-weight: bold;
      }

      input {
        width: 60%;
        padding: 10px;
        border-radius: 6px;
        margin: 0px 0 20px 0;
      }

      textarea {
        resize: none;
        width: 60%;
        height: 100px;
        padding: 5px;
        border-radius: 6px;
      }

      button {
        width: 40%;
        padding: 20px;
        border-radius: 25px;
        margin-top: 20px;
        border: 1px solid $informaticaBlue;
        color: $informaticaBlue;
        font-weight: bold;
        text-transform: uppercase;
        cursor: pointer;
        background-color: white;
        transition: all 0.15s ease-in;

        &:hover {
          background-color: $informaticaBlue;
          color: white;
        }
      }

      .sucess {
        color: red;
        border-radius: 50%;
      }
    }
  }
}
</style>
